/*eslint-disable */
const eventToIconMapper: any = {
  ROAD: 'zamkniecia-drog.svg',
  HAZARD: 'zagrozenia.svg',
  CONSTRUCTION: 'roboty-drogowe.svg',
  ACCIDENT: 'wypadki.svg',
  JAM: 'zagrozenia.svg',
  OTHER: 'zdarzenia.svg',
};

export default (capEventCode: string): any => {
  // eslint-disable-next-line no-prototype-builtins
  if (eventToIconMapper.hasOwnProperty(capEventCode)) {
    const icon = eventToIconMapper[capEventCode] as string;

    return icon;
  }
  return 'zagrozenia.svg';
};
